import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { createSelector } from 'reselect';

import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import { DragSource, DropTarget } from 'react-dnd';
import { findDOMNode } from 'react-dom';

import Collapse from '../../../components/Collapse';
import { getComponent } from '../../../components/types/Components';
import InlineEditor from '../../../components/types/InlineEditor';
import { InlineEditorActions } from '../../../actions/inlineEditor';
import { validateAndDispatch } from '../../../helpers/form';

import { ModalActions } from '../../../actions/modal';
import { PageActions } from '../../../actions/page';
import { ElementTypeActions } from '../../../actions/elementType';

// import '../styles/Tags.css';

const style = {
  border: '1px dashed gray',
  marginBottom: '.5rem',
  backgroundColor: 'white',
  cursor: 'pointer',
  paddingBottom: '20px',
};

class ElementTypeProperties extends PureComponent {
  static propTypes = {
    elementType: PropTypes.instanceOf(Map),
    dispatch: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.moveCard = this.moveCard.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  onSave = (propKey, meta) => {
    const { elementType, dispatch } = this.props;
    const metaKey = Object.keys(meta)[0];
    const formUid = `${propKey}-${metaKey}`;

    const action = ElementTypeActions.saveElementTypeProperty(
      elementType,
      propKey,
      meta,
    );
    const validation = {};

    return validateAndDispatch(dispatch, action, validation, {
      field: meta[metaKey],
    }).then(() => {
      dispatch(InlineEditorActions.unsetInlineEditState(formUid));
    });
  }

  toggleModal = () => {
    const { dispatch, currentElementTypeId } = this.props;

    dispatch(
      ModalActions.toggleModal({
        name: 'CreateElementTypePropertyModal',
        options: {
          currentElementTypeId,
        },
      }),
    );
  };

  togglePropertySettingsModal = (prop, isLocked) => {
    const { dispatch, elementType } = this.props;
    // console.log('toggle', prop, elementType);
    dispatch(
      ModalActions.toggleModal({
        name: 'EditTypePropertyModal',
        options: {
          type: 'elementType',
          typeId: elementType.get('id'),
          order: elementType.getIn(['props', prop, '_order'], elementType.get('props').size + 1),
          isLocked,
          prop,
        },
      }),
    );
  };

  toggleRenameMetaModal = (meta, e) => {
    const { dispatch, elementType } = this.props;
    e.stopPropagation();
    console.log('log', meta);
    dispatch(
      ModalActions.toggleModal({
        name: 'RenameElementTypeMetaPropertyModal',
        options: {
          elementTypeId: elementType.get('id'),
          metaKey: meta.metaKey,
          prop: meta.prop,
        },
      }),
    );
  }

  toggleRenameModal = (prop, e) => {
    const { dispatch, elementType } = this.props;
    e.stopPropagation();
    dispatch(
      ModalActions.toggleModal({
        name: 'RenameElementTypePropertyModal',
        options: {
          elementTypeId: elementType.get('id'),
          elementTypePropName: prop,
        },
      }),
    );
  }

  // toggleAddMetaModal = (prop, e) => {
  //   const { dispatch, elementType } = this.props;
  //   e.stopPropagation();
  //
  //   dispatch(
  //     ModalActions.toggleModal({
  //       name: 'AddElementTypeMetaPropertyModal',
  //       options: {
  //         typeId: elementType.get('id'),
  //         activeProp: prop,
  //       },
  //     }),
  //   );
  // }

  handleDeleteMeta = (meta, e) => {
    e.stopPropagation();
    this.props.dispatch(ElementTypeActions.deleteElementTypeMetaProperty(meta));
  }

  fieldSet = (k, val, propName, propType) => {
    const { elementType } = this.props;
    let propertyTypeEditor;
    const uid = `${propName}-${k}`;
    const bindData = {
      elementTypeId: elementType.get('id'),
      prop: propName,
      metaKey: k,
    };

    if (k.startsWith('_')) return null;

    // console.log('wut?', k, val, propName, obj);
    console.log('val', val);
    const fieldType = val && Map.isMap(val) && val.has('_type')
      ? val.get('_type')
      : 'String';
    const fieldValue = val && Map.isMap(val) && val.has('_value')
      ? val.get('_value')
      : val;
    const TypeComponent = getComponent(fieldType);
    propertyTypeEditor = TypeComponent
      ? <InlineEditor
          component={TypeComponent}
          ref="typeComponent"
          metaKey={k}
          customMeta
          propertyKey={propName}
          value={fieldValue}
          form={uid}
          showHelpText
          onSave={this.onSave}
        />
      : null;

    const isSystem = k && k.charAt(0) === '_';
    const renameMetaButton = isSystem
      ? ''
      : <button
          type="button"
          className="meta-btn btn btn-primary btn-xs"
          onClick={::this.toggleRenameMetaModal.bind(this, bindData)}
        >
          <i className="fa fa-pencil-square-o" />
        </button>;
    const deleteMetaButton = isSystem
      ? ''
      : <button
          type="button"
          className="meta-btn btn btn-danger btn-xs"
          onClick={::this.handleDeleteMeta.bind(this, bindData)}
        >
          <i className="fa fa-times" />
        </button>;

    return (
      <fieldset key={k} className="form-group">
        <label className="metakey">
          <strong>{k}</strong>
          <span className="action-btns">
            {renameMetaButton}{deleteMetaButton}
          </span>
        </label>
        {propertyTypeEditor}
      </fieldset>
    );
  }

  showDeleteWarning = (deleteMethod, propKey, e) => {
    e.stopPropagation();
    const { dispatch } = this.props;

    dispatch(
      ModalActions.toggleModal({
        name: 'DeleteConfirmationModal',
        options: {
          deleteType: 'elementTypeProperty',
          handleDelete: deleteMethod.bind(this),
          name: propKey,
        },
      }),
    );
  };

  deleteProp = prop => {
    const elementTypeId = this.props.elementType.get('id');
    this.props.dispatch(
      ElementTypeActions.deleteElementTypeProperty({
        elementTypeId,
        prop,
      }),
    );
  };

  toggleReducerState = (key, elementId, currentState) => {
    const { dispatch } = this.props;
    const reducerType = 'elementType';

    dispatch(
      PageActions.toggleState(key, elementId, reducerType, currentState),
    );
  }

  moveCard = (dragId, hoverId) => {
    const { dispatch, elementType } = this.props;
    const elementTypeId = elementType.get('id');
    dispatch(
      ElementTypeActions.updatePropsOrder(elementTypeId, dragId, hoverId),
    );
  };

  buildProperties = () => {
    const { elementType, collapseState } = this.props;
    if (!elementType) return null;
    const properties = elementType.get('props');

    if ((properties && !properties.size) || !properties) return <span />;

    let metaData = (
      <DndContainer>
        <span className={'children-elements'}>
          {properties
            .sortBy(p => p.get('_order'))
            .map((elementtype, propKey, props) => {
              if (propKey === '_global') return null;
              // console.log('prop', elementtype.toJSON(), propKey, props.toJSON());
              let propKeyState = collapseState
                ? collapseState.has(propKey)
                    ? collapseState.get(propKey)
                    : false
                : false;
              const isLocked = elementtype.get('_lock', null);
              const deleteAction = (!isLocked) ? this.showDeleteWarning.bind(
                this,
                this.deleteProp.bind(this, propKey),
                propKey,
              ) : null;
              const renameAction = (!isLocked) ? this.toggleRenameModal.bind(this, propKey) : null;

              return (
                <DndDraggable
                  elementType={elementType}
                  id={propKey}
                  index={props.getIn([propKey, '_order'])}
                  moveCard={this.moveCard}
                  key={propKey}
                >
                  <Collapse
                    key={propKey}
                    level="2"
                    header={propKey}
                    open={propKeyState}
                    stateAction={this.toggleReducerState.bind(
                      this,
                      propKey,
                      elementType.get('id'),
                      propKeyState,
                    )}
                    // addAction={this.toggleAddMetaModal.bind(this, propKey)}
                    deleteAction={deleteAction}
                    renameAction={renameAction}
                    settingsAction={this.togglePropertySettingsModal.bind(
                      this,
                      propKey,
                      isLocked,
                    )}
                  >
                    <div>
                      {elementtype
                        .map((prop, key) => {
                          let row;
                          switch (key) {
                            case '_default': // eslint-disable-line no-case-declarations
                              const propType = elementtype.getIn(
                                ['_type'],
                                null,
                              );
                              row = this.fieldSet(key, prop, propKey, propType);
                              break;
                            case '_type':
                            case '_display':
                            case '_readOnly':
                            case '_required':
                            case '_helptext':
                            case '_comment':
                            case '_order':
                            default:
                              // console.log('default row', key, prop, propKey);
                              row = this.fieldSet(key, prop, propKey);
                              // row = <div key={key}>{key}</div>;
                              break;
                          }
                          return row;
                        })
                        .toArray()}
                    </div>
                  </Collapse>
                </DndDraggable>
              );
            })
            .toArray()}
        </span>
      </DndContainer>
    );

    return metaData;
  };

  render() {
    const { collapseState, elementType } = this.props;

    let properties = collapseState
      ? collapseState.has('properties') ? collapseState.get('properties') : true
      : true;

    return (
      <div>
        <Collapse
          level="1"
          header="Properties"
          help=""
          open={properties}
          stateAction={this.toggleReducerState.bind(
            this,
            'properties',
            elementType.get('id'),
            properties,
          )}
        >
          <button
            onClick={::this.toggleModal}
            type="button"
            className="btn btn-primary"
          >
            <i className="fa fa-plus" /> New Property
          </button>
          {this.buildProperties()}
        </Collapse>
      </div>
    );
  }
}

@DragDropContext(HTML5Backend)
class DndContainer extends PureComponent {
  render() {
    return <div>{this.props.children}</div>;
  }
}

const cardSource = {
  beginDrag(props) {
    const { id, index } = props;
    return {
      id,
      index,
    };
  },

  endDrag(props, monitor, _component) {
    const { dispatch, elementType } = props;
    if (!monitor.didDrop()) {
      return;
    }
    dispatch(ElementTypeActions.updateElementTypeProperties(elementType));
  },
};

const cardTarget = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index;
    const dragId = monitor.getItem().id;
    const hoverIndex = props.index;
    const hoverId = props.id;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
    const clientOffset = monitor.getClientOffset();
    const hoverClientY = clientOffset.y - hoverBoundingRect.top;

    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return;
    }

    // Dragging upwards
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return;
    }

    props.moveCard(dragId, hoverId);
    monitor.getItem().index = hoverIndex; // eslint-disable-line no-param-reassign
  },
};

// eslint-disable-next-line new-cap, no-shadow
// eslint-disable-next-line new-cap, no-shadow
@DropTarget('card', cardTarget, conn => ({
  connectDropTarget: conn.dropTarget(),
}))
@connect()
@DragSource('card', cardSource, (conn, monitor) => ({
  connectDragSource: conn.dragSource(),
  isDragging: monitor.isDragging(),
}))
class DndDraggable extends PureComponent {
  render() {
    const { isDragging, connectDragSource, connectDropTarget } = this.props;
    const opacity = isDragging ? 0 : 1;

    return connectDragSource(
      connectDropTarget(
        <div style={{ ...style, opacity }}>{this.props.children}</div>,
      ),
    );
  }
}

const collapseStateSelector = (state, props) => {
  return state.pages.getIn(['elementType', props.currentElementTypeId], false);
};

const inlineEditorSelector = state => state.inlineEditors.get('editors');

const ElementTypePropertiesContainerSelector = createSelector(
  [inlineEditorSelector, collapseStateSelector],
  (editors, collapseState) => ({
    editors,
    collapseState,
  }),
);

@connect(ElementTypePropertiesContainerSelector)
export default class ElementPropertiesContainer extends PureComponent {
  static propTypes = {
    dispatch: PropTypes.func,
    elementType: PropTypes.instanceOf(Map),
  };

  render() {
    if (!this.props.elementType) return <div />;
    return <ElementTypeProperties {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/views/ProjectSettings/ElementType/ElementTypeProperties.js